import mediumZoom from 'medium-zoom';
import Swiper, { Navigation, Pagination } from 'swiper';
document.addEventListener('DOMContentLoaded', function () {
    const aboutUsSwiper = document.querySelector('.about-us-swiper');
    new Swiper(aboutUsSwiper, {
        modules: [Navigation, Pagination],
        slidesPerView: 1.5,
        centeredSlides: true,
        spaceBetween: 20,
        breakpoints: {
            768: {
                slidesPerView: 2.5,
                spaceBetween: 20,
            },
            992: {
                slidesPerView: 4.5,
                spaceBetween: 20,
            },
        },
        autoplay: {
            delay: 5000,
        },
        loop: true,
        threshold: 4,
        updateOnImagesReady: true,
    });
    mediumZoom('[data-zoomable]', {
        margin: 0,
        background: 'rgba(0,0,0,0.75)',
        scrollOffset: 0,
    });
});
